<template>

    <HXContentCard title="LOCALIZAR RUTAS ACTIVAS" :toBack="{ name: 'ListaEntregas' }">
        <div class="row mt-2 justify-content-center">
            <!-- {{ rutasOrganizadas }} -->
            <div class="col-11 row bg-dark p-2 rounded border">
                <div class="col-10 pl-0 pr-2">
                    <div id="map-container" :class="{ 'dark-mode': isDarkMode }"
                        style="height: 70vh; width: 100%; position: relative;">
                        <l-map ref="map" :zoom="zoom" :center="center" :options="mapOptions"
                            style="height: 100%; width: 100%;" @ready="onMapReady">
                            <l-tile-layer :url="currentMapStyle.url" :attribution="attribution" />
                            <l-control-scale position="bottomleft" :imperial="false" :metric="true" />
                            <template v-for="(ruta, puntoEntregaId) in rutasOrganizadas">
                                <l-polyline :key="puntoEntregaId" :lat-lngs="ruta.coordenadas" :color="getRandomColor()"
                                    :weight="5" :opacity="0.7" @mouseover="highlightRoute" @mouseout="resetHighlight" />

                                <l-marker :key="'start-' + puntoEntregaId" :lat-lng="ruta.coordenadas[0]"
                                    :icon="customIconIni" />

                                <l-marker :key="'end-' + puntoEntregaId"
                                    :lat-lng="ruta.coordenadas[ruta.coordenadas.length - 1]" :icon="customIconFin">
                                    <l-popup>
                                        <div class="custom-popup">
                                            <div class="popup-principal">
                                                <div class="popup-header">
                                                    <h4 class="route-title">
                                                        <span class="material-icons">
                                                            <i class="fa-solid fa-route"></i>
                                                        </span>
                                                        {{ ruta.nombreRuta || "Sin ruta" }}
                                                    </h4>
                                                </div>
                                                <div class="placa">
                                                    <div class="placa-informacion">
                                                        <span class="col">COL</span>
                                                        <span class="numeroPlaca">{{ ruta.placa || "Sin placa" }}</span>
                                                    </div>
                                                </div>
                                                <div class="popup-content">
                                                    <div class="info-item">
                                                        <span class="material-icons">
                                                            <i class="fa-solid fa-truck-fast"></i>
                                                        </span>
                                                        <div class="info-text">
                                                            <label>Punto de entrega</label>
                                                            <p>{{ ruta.lugarEntrega || "Sin punto de entrega" }}</p>
                                                        </div>
                                                    </div>

                                                    <div class="info-item">
                                                        <span class="material-icons">
                                                            <i class="fa-solid fa-calendar-days"></i>
                                                        </span>
                                                        <div class="info-text">
                                                            <label>Inicio programado</label>
                                                            <p>{{ ruta.fechaHoraInicio || "Sin fecha de inicio" | timeSince }}
                                                            </p>
                                                        </div>
                                                    </div>

                                                    <div class="info-item">
                                                        <span class="material-icons">
                                                            <i class="fa-solid fa-file-circle-question"></i>
                                                        </span>
                                                        <div class="info-text">
                                                            <label>Descripción</label>
                                                            <p>{{ ruta.descripcionRuta || "Sin descripción" }}</p>
                                                        </div>
                                                    </div>

                                                    <div class="status-container">
                                                        <div
                                                            :class="ruta.estadoPuntoEntrega === 'En camino' ? 'status-badge' : 'status-badge-warning'">
                                                            {{ ruta.estadoPuntoEntrega || "Sin estado" }}
                                                        </div>
                                                        <div class="coordinates-badge">
                                                            <span class="material-icons">
                                                                <i class="fa-solid fa-location-dot"></i>
                                                            </span>
                                                            {{ ruta.coordenadas.length }} coordenadas
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </l-popup>
                                </l-marker>
                            </template>
                        </l-map>

                        <!-- Controles de mapa -->
                        <div class="map-controls">
                            <select v-model="currentMapStyleIndex" @change="changeMapStyle" class="map-style-select">
                                <option v-for="(style, index) in mapStyles" :key="index" :value="index">
                                    {{ style.name }}
                                </option>
                            </select>
                            <button @click="toggleDarkMode" class="dark-mode-toggle">
                                {{ isDarkMode ? '☀️' : '🌙' }}
                            </button>
                        </div>
                    </div>
                </div>
                <div class="col-2 bg-dark border p-2 rounded">
                    <b-list-group v-for="(ruta, index) in rutasOrganizadas" :key="index">
                        <b-list-group-item active class="flex-column align-items-start mb-2 pointer"
                            @click="redirectMap(ruta.coordenadas[ruta.coordenadas.length - 1])">
                            <div class="d-flex w-100 justify-content-between">
                                <h5 class="mb-1">{{ ruta.lugarEntrega }}</h5>
                                <small>{{ ruta.ubicacion }}</small>
                            </div>
                            <small>{{ ruta.estadoPuntoEntrega }}</small>
                        </b-list-group-item>
                    </b-list-group>
                </div>
            </div>
        </div>
    </HXContentCard>
</template>

<script>
import { LMap, LTileLayer, LMarker, LPolyline, LControlScale, LPopup } from "vue2-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import moment from "moment/moment";
import moment_timezone from "moment-timezone";
import "moment/locale/es";

export default {
    components: {
        LMap,
        LTileLayer,
        LMarker,
        LPolyline,
        LControlScale,
        LPopup,
    },
    data() {
        return {
            url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png",
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            zoom: 12,
            center: [4.7034775, -74.1218263],
            customIconIni: L.icon({
                iconUrl: require("@/assets/images/homeIcon.png"),
                iconSize: [40, 45],
                iconAnchor: [20, 45],
            }),
            customIconFin: L.icon({
                iconUrl: require("@/assets/images/vehiculoHelexium.png"),
                iconSize: [40, 45],
                iconAnchor: [20, 45],
            }),
            rutasOrganizadas: {},
            isDarkMode: false,
            currentMapStyleIndex: 0,
            mapStyles: [
                { name: "Estándar", url: "https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" },
                { name: "Acuarela", url: "https://stamen-tiles-{s}.a.ssl.fastly.net/watercolor/{z}/{x}/{y}.jpg" },
                { name: "Terreno", url: "https://stamen-tiles-{s}.a.ssl.fastly.net/terrain/{z}/{x}/{y}.jpg" },
                { name: "Oscuro", url: "https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}.png" },
            ],
            mapOptions: {
                autoClosePopup: false,
            },
            actualizarCoordenadas: null,
        };
    },
    computed: {
        currentMapStyle() {
            return this.mapStyles[this.currentMapStyleIndex];
        },
    },
    methods: {
        async getRutaCompleta() {
            try {
                let res = await this.$store.dispatch("hl_get", {
                    path: "EntregasApp/GetCoordenadasMapa/" + this.$route.params.id,
                });
                if (res && res.success && res.data) {
                    this.organizarRutas(res.data);
                    console.log("ESTA ES LA RESPUESTAAA", res.data)
                } else {
                    console.log("No se encontraron coordenadas para esta ruta");
                }
            } catch (error) {
                console.log("Error al obtener los datos:", error);
            }
        },
        organizarRutas(data) {
            const rutas = {};
            data.forEach(coord => {
                if (!rutas[coord.puntoEntregaId]) {
                    rutas[coord.puntoEntregaId] = {
                        coordenadas: [],
                        estadoPuntoEntrega: coord.estadoPuntoEntrega,
                        placa: coord.placa || "Sin placa",
                        lugarEntrega: coord.lugarEntrega || "Sin lugar de entrega",
                        fechaHoraInicio: coord.fechaHoraInicio || "Sin fecha de inicio",
                        descripcionRuta: coord.descripcionPuntoEntrega || "Sin descripción",
                        ubicacion: coord.ubicacion || "Sin ubicación",
                    };
                }
                rutas[coord.puntoEntregaId].coordenadas.push([parseFloat(coord.latUbicacionActual), parseFloat(coord.longUbicacionActual)]);
            });
            this.rutasOrganizadas = rutas;
            this.$nextTick(() => {
                setTimeout(this.ajustarVistaMapa, 100);
            });
        },
        ajustarVistaMapa() {
            if (this.$refs.map && Object.keys(this.rutasOrganizadas).length > 0) {
                const bounds = L.latLngBounds(
                    Object.values(this.rutasOrganizadas).flatMap(ruta => ruta.coordenadas)
                );
                this.$refs.map.mapObject.fitBounds(bounds);
                this.$refs.map.mapObject.invalidateSize();
            }
        },
        getRandomColor() {
            return "#" + Math.floor(Math.random() * 16777215).toString(16);
        },
        onMapReady() {
            this.getRutaCompleta();
            this.forceMapUpdate();
        },
        forceMapUpdate() {
            if (this.$refs.map) {
                this.$refs.map.mapObject.invalidateSize();
                setTimeout(() => {
                    this.$refs.map.mapObject.invalidateSize();
                }, 200);
            }
        },
        highlightRoute(e) {
            const layer = e.target;
            layer.setStyle({
                weight: 8,
                opacity: 1,
            });
        },
        resetHighlight(e) {
            const layer = e.target;
            layer.setStyle({
                weight: 5,
                opacity: 0.7,
            });
        },
        toggleDarkMode() {
            this.isDarkMode = !this.isDarkMode;
            if (this.isDarkMode) {
                this.currentMapStyleIndex = 3; // Índice del estilo oscuro
            } else {
                this.currentMapStyleIndex = 0; // Índice del estilo estándar
            }
            this.changeMapStyle();
        },
        changeMapStyle() {
            if (this.$refs.map) {
                this.$refs.map.mapObject.eachLayer((layer) => {
                    if (layer instanceof L.TileLayer) {
                        this.$refs.map.mapObject.removeLayer(layer);
                    }
                });
                L.tileLayer(this.currentMapStyle.url, { attribution: this.attribution }).addTo(this.$refs.map.mapObject);
            }
        },
        redirectMap(coordenadas) {
            if (this.$refs.map && this.$refs.map.mapObject) {
                this.$refs.map.mapObject.flyTo(coordenadas, 16, {
                    duration: 2,
                });
            }
        },
    },
    mounted() {
        window.addEventListener('resize', this.forceMapUpdate);
        this.actualizarCoordenadas = setInterval(this.getRutaCompleta, 5000);
    },
    beforeDestroy() {
        window.removeEventListener('resize', this.forceMapUpdate);
        if (this.actualizarCoordenadas) {
            clearInterval(this.actualizarCoordenadas);
        }
    },
    filters: {
        formatDate(date) {
            return date ? moment(date).locale("es").format('D MMM YYYY') : "No hay fecha registrada";
        },
        timeSince(dateString, timezone = "America/Bogota") {
            const dateInBogota = moment_timezone.tz(dateString, timezone);
            return dateInBogota.format("D MMM YYYY hh:mm A");
        },
    },
};
</script>

<style>
@import '~leaflet/dist/leaflet.css';

#map-container {
    position: relative;
    z-index: 0;
    transition: all 0.3s ease;
}

#map-container.dark-mode {
    filter: invert(100%) hue-rotate(180deg) brightness(95%) contrast(90%);
}

.leaflet-container {
    width: 100%;
    height: 100%;
}

.leaflet-popup-content-wrapper {
    padding: 0 !important;
    overflow: hidden;
}

.leaflet-popup-content {
    margin: 0 !important;
    width: 300px !important;
}

.custom-popup .popup-principal {
    width: 100%;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.custom-popup .popup-header {
    background-color: #f21343;
    color: white;
    padding: 16px;
}

.custom-popup .route-title {
    margin: 0;
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 1.2rem;
    color: white;
}

.custom-popup .route-title .material-icons {
    font-size: 24px;
}

.custom-popup .placa {
    background: linear-gradient(145deg, #f0f0f0, #ffffff);
    margin: 16px auto;
    width: 200px;
    border: 2px solid #000;
    border-radius: 4px;
    padding: 8px;
}

.custom-popup .placa-informacion {
    text-align: center;
}

.custom-popup .placa-informacion .col {
    .custom-popup .placa-informacion .col {
        display: block;
        font-size: 0.8rem;
        color: #000000;
        margin-bottom: 4px;
    }
}

.custom-popup .placa-informacion .numeroPlaca {
    font-size: 1.5rem;
    font-weight: bold;
    letter-spacing: 2px;
    color: #000;
}

.custom-popup .popup-content {
    padding: 16px;
}

.custom-popup .info-item {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
    align-items: flex-start;
}

.custom-popup .info-item .material-icons {
    color: #666;
    font-size: 20px;
}

.custom-popup .info-item .info-text {
    flex: 1;
}

.custom-popup .info-item .info-text label {
    font-size: 0.8rem;
    color: #666;
    margin-bottom: 4px;
    display: block;
}

.custom-popup .info-item .info-text p {
    margin: 0;
    color: #333;
}

.custom-popup .status-container {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid #eee;
}

.custom-popup .status-badge {
    padding: 6px 12px;
    border-radius: 16px;
    font-size: 0.9rem;
    font-weight: 500;
    background-color: #E8F5E9;
    color: #2E7D32;
}

.custom-popup .status-badge-warning {
    padding: 6px 6px;
    border-radius: 16px;
    font-size: 0.8rem;
    font-weight: 200;
    background-color: #ffefbbde;
    color: #a38500;
}

.custom-popup .coordinates-badge {
    display: flex;
    align-items: center;
    gap: 4px;
    color: #666;
    font-size: 0.9rem;
}

.custom-popup .coordinates-badge .material-icons {
    font-size: 18px;
}

.map-controls {
    position: absolute;
    top: 10px;
    right: 10px;
    z-index: 1000;
    display: flex;
    gap: 10px;
}

.map-style-select,
.dark-mode-toggle {
    padding: 5px 10px;
    border: none;
    border-radius: 5px;
    background-color: white;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
    cursor: pointer;
    transition: all 0.3s ease;
}

.map-style-select:hover,
.dark-mode-toggle:hover {
    background-color: #f0f0f0;
}

.dark-mode-toggle {
    font-size: 20px;
    line-height: 1;
}

.dark-mode .leaflet-popup-content-wrapper {
    background-color: rgba(40, 44, 52, 0.9);
    color: #f0f0f0;
}

.dark-mode .custom-popup h3 {
    color: #61dafb;
}

.dark-mode .map-style-select,
.dark-mode .dark-mode-toggle {
    background-color: #333;
    color: white;
}

.dark-mode .map-style-select:hover,
.dark-mode .dark-mode-toggle:hover {
    background-color: #444;
}
</style>